export default "__VITE_ASSET__Byqh_O46__"